import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=36bfa97c"
import script from "./ClientFilter.vue?vue&type=script&lang=js"
export * from "./ClientFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports